import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 402.000000 280.000000">
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,280.000000) scale(0.100000,-0.100000)" >


<path d="M1807 2103 c-4 -3 -7 -17 -7 -29 0 -23 3 -23 107 -26 93 -3 108 -5
111 -20 3 -15 -9 -18 -105 -20 -93 -3 -108 -5 -111 -20 -3 -15 5 -18 52 -18
49 0 56 -2 56 -20 0 -18 -7 -20 -55 -20 -51 0 -55 -2 -55 -24 0 -32 34 -38
223 -35 84 1 153 -2 153 -7 2 -9 -30 -57 -78 -121 -16 -20 -28 -40 -28 -44 0
-5 63 -9 140 -9 l140 0 86 118 c48 64 116 156 151 203 34 48 63 89 63 93 0 8
-835 8 -843 -1z"/>
<path d="M1702 2078 c3 -25 36 -37 48 -17 13 20 0 39 -27 39 -20 0 -24 -4 -21
-22z"/>
<path d="M1700 1986 c0 -11 10 -16 31 -16 38 0 35 24 -4 28 -19 2 -27 -1 -27
-12z"/>
<path d="M1700 1900 c0 -14 7 -20 23 -20 13 0 26 3 30 6 12 12 -6 34 -29 34
-17 0 -24 -6 -24 -20z"/>
<path d="M2038 1648 c-16 -13 -88 -113 -88 -123 0 -3 60 -5 134 -5 l134 0 46
61 c25 34 46 65 46 70 0 14 -253 11 -272 -3z"/>
<path d="M1737 1247 l-169 -232 409 -3 c224 -1 414 0 420 3 7 2 13 16 13 29 0
25 0 25 -107 28 -93 3 -108 5 -111 21 -3 15 7 17 107 17 104 0 111 1 111 20 0
18 -7 20 -55 20 -48 0 -55 2 -55 20 0 18 7 20 55 20 52 0 55 1 55 25 l0 25
-185 0 c-142 0 -185 3 -185 13 1 6 34 57 75 112 41 55 75 103 75 108 0 4 -64
7 -142 7 l-143 0 -168 -233z"/>
<path d="M2453 1224 c-3 -8 -1 -20 5 -26 16 -16 47 -5 50 20 3 18 -1 22 -23
22 -14 0 -28 -7 -32 -16z"/>
<path d="M2460 1136 c0 -16 37 -28 46 -15 8 14 -5 29 -27 29 -10 0 -19 -6 -19
-14z"/>
<path d="M2478 1063 c-10 -3 -18 -13 -18 -24 0 -14 7 -19 25 -19 18 0 25 5 25
19 0 23 -8 29 -32 24z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
